import ScopedBlogCreate from '@/components/blog/scoped-blog-create';
import { ROUTES } from '@/config/routes';
import { clubSidebar } from '@/config/sidebarConfig';
import { useAuthStore } from '@/stores/auth-store';

export default function ClubBlogCreate() {
  const user = useAuthStore(s => s.user);
  const clubId = user?.clubId;

  return (
    <ScopedBlogCreate
      sidebarConfig={clubSidebar}
      listRoute={ROUTES.CLUB_BLOG}
      scopePayload={clubId ? { clubId } : undefined}
    />
  );
}
